'use client';

import { c as _c } from "react/compiler-runtime";
import './sac-empty.scss';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { LogoEmptySearch } from '@sola/ark-core/logos/empty-search.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
interface SacEmptyProps {
  resetFilters?: () => void;
}
export const SacEmpty: React.FC<FlexibleContentProps & SacEmptyProps> = t0 => {
  const $ = _c(28);
  const {
    resetFilters
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["children"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="display-block margin-right-auto margin-left-auto"><LogoEmptySearch aria-hidden={true} /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("children:sac.resetTitle");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <h2 className="display display-md">{t3}</h2>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("children:sac.resetMessage");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <p className="body body-md">{t5}</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div>{t2}{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("children:sac.resetFilters");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== resetFilters || $[16] !== t8) {
    t9 = <ButtonStyle><button onClick={resetFilters} className="w-full md:w-fit" type="button">{t8}</button></ButtonStyle>;
    $[15] = resetFilters;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("children:sac.selectAChildForMe");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <ButtonStyle variant="secondary" purpose="neutral"><Link href="/sponsor-a-child/child-bio" className="w-full md:w-fit">{t10}</Link></ButtonStyle>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div className="flex flex-col md:flex-row gap-comfy-xs items-center justify-center">{t9}{t11}</div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7) {
    t13 = <div className="SacEmpty text-center gap-comfy-lg">{t7}{t12}</div>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};